// extracted by mini-css-extract-plugin
export default {"text":"noApplicableData_text__1DOvO"};